import { HttpResponse } from '@angular/common/http';
import { Component, OnInit } from '@angular/core';
import { IconProp } from '@fortawesome/fontawesome-svg-core';
import { faMinusCircle } from '@fortawesome/free-solid-svg-icons';
// import "leaflet";
// declare let L;
import * as L from "leaflet";
import { Subject } from 'rxjs/internal/Subject';
import { takeUntil } from 'rxjs/operators';
import { Events } from 'src/app/classes/events';
import { VanEvents } from 'src/app/classes/van-events';
import { VanEventsAddEvent } from 'src/app/classes/van-events-add-event';
import { EventsDeltaService } from 'src/app/services/events-delta.service';
import { EventsService } from 'src/app/services/events.service';
import { LoggerService } from 'src/app/services/logger.service';
import { ManageVansService } from 'src/app/services/manage-vans.service';
import { ToastService } from 'src/app/services/toast.service';
@Component({
  standalone: false,
  selector: 'app-manage-vans',
  templateUrl: './manage-vans.component.html',
  styleUrls: ['./manage-vans.component.scss']
})
export class ManageVansComponent implements OnInit {
  faMinusCircle = faMinusCircle as IconProp;
  unsubscribe$: Subject<boolean> = new Subject();
  events: Events;
  vanEvents: VanEvents;
  addEvents: Array<VanEventsAddEvent> = [];
  constructor(
    private eventsService: EventsService,
    private eventsDeltaService: EventsDeltaService,
    private logger: LoggerService,
    private manageVansService: ManageVansService,
    private toastService: ToastService,) { }

  ngOnInit(): void {
    this.addEvents = this.eventsService.eventData$.getValue()?.vanEvents.addEvents || [];
    this.addEvents.sort((a, b) => (a.driverId > b.driverId) ? -1 : 1);
    this.subscribeToEventDeltas();
  }

  subscribeToEventDeltas(): void {
    this.eventsDeltaService.getEventData().pipe(takeUntil(this.unsubscribe$))
    .subscribe((events: Events) => {
        if (events) {
          this.addEvents = events.vanEvents.addEvents;
          this.addEvents.sort((a, b) => (a.driverId > b.driverId) ? -1 : 1);
        }
      });
  }

  ngOnDestroy(): void {
    this.unsubscribe$.next(true);
    this.unsubscribe$.complete();
  }

  unassignVan(vanName){
    this.manageVansService.unassignVan(vanName)
    .subscribe({
      next: (resp: HttpResponse<any>) => {
        this.logger.debug(`PUT unassign van response:`, resp, 'http');
        if(resp.status === 202){
          setTimeout(() => {
            this.eventsDeltaService.getDeltas();
          }, 500);
          this.toastService.show(`Van unassigned`, { classname: 'bg-success text-light', delay: 4000 });
        }else{
          this.toastService.show(`Error saving profile!`, { classname: 'bg-danger text-light', delay: 4000 });
        }
      },
      error: (err) => {
        this.logger.error('Failed to unassign van:', err);
        this.toastService.show(`Error unassigning van`, { classname: 'bg-danger text-light', delay: 4000 });
      }
    });
  }

  zoomToVan(van: VanEventsAddEvent){
    this.manageVansService.updateZoomLocation(new L.LatLng(van.latitude, van.longitude));
  }


}
